'use client'

import Script from 'next/script'

const GoogleAnalytics = ({tagId, gaId, dataLayerName = 'dataLayer', allowEnhancedConversions, debugMode, disabled = false}) => {
    if (disabled || !gaId) {
        return null
    }

    const config = {}
    if (allowEnhancedConversions) config.allow_enhanced_conversions = true
    if (debugMode) config.debug_mode = true
    const configArgs = Object.keys(config).length ? `, ${JSON.stringify(config)}` : ''

    return (
        <>
            <Script
                id={`${tagId}`}
                src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
                strategy="afterInteractive"
            />
            <Script
                id={`${tagId}-init`}
                dangerouslySetInnerHTML={{__html:
                    `
                    window['${dataLayerName}'] = window['${dataLayerName}'] || [];
                    function gtag(){window['${dataLayerName}'].push(arguments);}
                    gtag('js', new Date());
                    gtag('config', '${gaId}'${configArgs});
                    `
                }}
            />
        </>
    )
}
export default GoogleAnalytics
